import React from 'react';

const Footer = () => (
  <footer>
    &copy; 2025 Peeo Mocktails. All rights reserved.
  </footer>
);

export default Footer;